import React, { Component } from 'react';

import {Breadcrumb, Radio} from '@jd/find-react';

import KeeVue from '../base/KeeVue.js'
export default class FsBreadcrumb extends KeeVue {
    constructor(props){
        super(props);
        this.state = { };
    };

    componentDidMount() {
        this.registComponent();
    }

    componentWillReceiveProps(nextProps){
        this.refresh();
    }

    setTitle=(title)=> {
        this.props.component.cp.title = title;
    }

    render() {
        let separator =  this.props.component.cp.separator
        let items = this.props.component.cp.items;

        if(this.props.debug == true) {
            separator = '>';
            items = '首页,页面一'
        }
        let itemArr = items.split(",");
        return (
            <div>
                <Breadcrumb >

                    {
                        itemArr.map((item,index)=>{
                            return  <Breadcrumb.Item key={item}>{item}</Breadcrumb.Item>
                        })
                    }
                </Breadcrumb>

            </div>
        )
    }
}